import { formatDate } from '@packages/shared/core/common/utils/date';
import { todayInMilliseconds } from '@packages/shared/core/common/utils';
import { DailyHoroscope, DailyHoroscopeComponentType } from '../entities';
import {
  DailyHoroscopeComponentUnionTypeDto,
  DailyHoroscopeResponseTypeDto,
  DailyHoroscopeScoringComponentTypeDto,
  DailyHoroscopeTextComponentTypeDto,
  DailyHoroscopeYesAndNoComponentTypeDto,
} from '../services/dto';

export const mapDailyHoroscopeDtoToEntity = (horoscope: DailyHoroscopeResponseTypeDto): DailyHoroscope => {
  const isHoroscopeComponent = (comp: DailyHoroscopeComponentUnionTypeDto, type: DailyHoroscopeComponentType) =>
    comp.type === type;

  const getHoroscopeComponent = <T extends DailyHoroscopeComponentUnionTypeDto>(
    horoscopeComponents: Array<DailyHoroscopeComponentUnionTypeDto>,
    type: DailyHoroscopeComponentType,
  ): T => {
    const component = horoscopeComponents.find((comp): comp is T => isHoroscopeComponent(comp, type));

    if (!component) {
      throw new Error(`Missing horoscope component: ${type}`);
    }

    return component;
  };

  const horoscopeTextComponent = getHoroscopeComponent<DailyHoroscopeTextComponentTypeDto>(
    horoscope.components,
    DailyHoroscopeComponentType.HOROSCOPE,
  );

  const horoscopeScoringComponent = getHoroscopeComponent<DailyHoroscopeScoringComponentTypeDto>(
    horoscope.components,
    DailyHoroscopeComponentType.SCORING,
  );

  const horoscopeYesAndNoComponent = getHoroscopeComponent<DailyHoroscopeYesAndNoComponentTypeDto>(
    horoscope.components,
    DailyHoroscopeComponentType.YES_AND_NO,
  );

  return {
    period: 'today',
    date: formatDate(new Date(todayInMilliseconds()), 'MMMM D, YYYY'),
    text: horoscopeTextComponent.model.text_block.description,
    focuses: horoscopeScoringComponent.model.sphere_items.map((sphere) => ({
      name: sphere.type,
      percent: sphere.percentage,
    })),
    essentials: horoscopeYesAndNoComponent.model.yes_items.join(', '),
  };
};

